import React, { useState, useEffect } from 'react';
import PlusMinus2 from './PlusMinus2/PlusMinus2';

export type PlusMinusProps = {
  onChange: (value: number) => void;
  value: number;
  min: number;
  max: number;
  testID?: string;
};

/**
 * An uncontrolled wrapper around PlusMinus2.
 * Maintains internal state and initializes from props.value on mount.
 * Used in legacy AIQ (Additional Information Questions) flows.
 */
function PlusMinus(props: PlusMinusProps) {
  const { onChange, min, max, testID } = props;
  const [value, setValue] = useState<number>(0);

  useEffect(() => {
    if (props.value !== undefined && props.value >= min && props.value <= max) {
      setValue(props.value);
    }
    // This is an uncontrolled component - only process value prop on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (newValue: number): void => {
    // Enforce min/max constraints before updating state
    if (newValue >= min && newValue <= max) {
      setValue(newValue);
      onChange(newValue);
    }
  };

  return (
    <PlusMinus2 value={value} onChange={handleChange} min={min} max={max} testID={testID || 'plus-minus'} />
  );
}

export default PlusMinus;
